import React from 'react';


function HealthCheck() {
    return(
        <h3>I am working good</h3>
    )
}


export default HealthCheck;